import { render, staticRenderFns } from "./ModuleReportV2.vue?vue&type=template&id=39f14aaa&scoped=true&"
import script from "./ModuleReportV2.vue?vue&type=script&lang=js&"
export * from "./ModuleReportV2.vue?vue&type=script&lang=js&"
import style0 from "./ModuleReportV2.vue?vue&type=style&index=0&id=39f14aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f14aaa",
  null
  
)

export default component.exports